import React from "react";
import { Link as RouterLink, LinkProps } from "react-router-dom";

interface Props {
  ignoreDefaultStyle?: boolean;
}

export default function Link(
  props: Props & LinkProps & React.RefAttributes<HTMLAnchorElement>
) {
  const { className, ignoreDefaultStyle, ...rest } = props;

  const getClassNames = () => {
    const defaultClasses =
      "text-sm font-semibold underline font-inter active:text-primaryRed hover:text-promGray2";

    if (className && ignoreDefaultStyle) {
      return className;
    }

    if (className) {
      return `${defaultClasses} ${className}`;
    }

    return defaultClasses;
  };

  return <RouterLink {...rest} className={getClassNames()} />;
}

Link.defaultProps = {
  ignoreDefaultStyle: false,
};
